import React from "react"
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({
  isLoggin,
  redirectPath = '/sign-in',
  children,
}) => {

  if (!isLoggin) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

export default ProtectedRoute
